import React from "react";
import { motion } from "framer-motion";
import "./ourclient.css";

// Client logos (replace with your actual image paths)
import raymond from "../../assets/clients/raymond.jpeg";
import digigram from "../../assets/clients/digjam.jpeg";
import honda from "../../assets/clients/honda.png";
import hyundai from "../../assets/clients/hyundai.png";
import poorvika from "../../assets/clients/poorvika.png";
import nexa from "../../assets/clients/nexa.png";
import sujana from "../../assets/clients/sujana.jpeg";
import maruthi from "../../assets/clients/maruthi.jpeg";
import tcs from "../../assets/clients/tcs.jpeg";
import kalyani from "../../assets/clients/kalyani.jpeg";

const clients = [
  { src: honda, alt: "Honda" },
  { src: digigram, alt: "Digigram" },
  { src: nexa, alt: "Nexa" },
  { src: raymond, alt: "Raymond" },
  { src: hyundai, alt: "Hyundai" },
  { src: poorvika, alt: "Poorvika" },
  { src: sujana, alt: "Sujana" },
  { src: maruthi, alt: "Maruthi" },
  { src: tcs, alt: "TCS" },
  { src: kalyani, alt: "Kalyani" },
];

function OurClients() {
  return (
    <>
      <section style={{ marginTop: "50px" }}>
        <div className="heading-head">
          <h3 className="heading-h3">Our Clients</h3>
        </div>
      </section>

      <section className="our-clients-section">
        <div className="our-clients-container">
          {/* Motion Scroll (infinite loop) */}
          <motion.div
            className="our-clients-track"
            animate={{ x: ["0%", "-100%"] }}
            transition={{
              ease: "linear",
              duration: 100,
              repeat: Infinity,
            }}
          >
            {[...clients, ...clients].map((client, i) => (
              <div className="client-item" key={i}>
                <img src={client.src} alt={client.alt} />
              </div>
            ))}
          </motion.div>
        </div>
      </section>
    </>
  );
}

export default OurClients;
